import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createFileExportFailed, createFileExportSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createFileExport(action) {
  try {
    const url = `${BACKEND_URL}/registries/file-export`;
    const response = yield makeRequest(url, action.payload, action, 'POST', true);
    if (response.status === CREATED) {
      yield put(createFileExportSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(createFileExportFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createFileExportFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
